const SMS = 1;
const EMAIL = 2;
const PUSH = 3;
const INTERNAL = 4;
const PASSAGE_VIEW = 5;

export default {
  SEARCH_MIN_LETTERS: 1,
  LIMIT: 15,
  ITEMS_LENGHT_FOR_AUTOROMPLETE: 10,
  TARIFF: {
    maxAmountPerPayment: 5000,
    optionsKeys: { SMS, EMAIL, PUSH, INTERNAL, PASSAGE_VIEW },
    options: [
      {
        option: "is_sms_on",
        user: "phone",
        name: "СМС информирование",
        key: SMS,
      },
      {
        option: "is_email_on",
        user: "email",
        name: "Email информирование",
        key: EMAIL,
      },
      { option: "is_push_on", name: "Push Уведомления", key: PUSH },
      {
        option: "is_internal_notification_on",
        name: "Доступ к уведомлениям в Личном кабинете",
        key: INTERNAL,
      },
      {
        option: "is_passage_view_on",
        name: "Доступ к проходам в Личном кибинете",
        key: PASSAGE_VIEW,
      },
    ],
    permissionToChange: {
      all: [SMS, EMAIL, PUSH],
      admin: [SMS, EMAIL, PUSH, INTERNAL, PASSAGE_VIEW],
    },
  },
  ROLES: {
    SUPERADMIN: "Главный администратор",
    TEACHER: "Учитель",
    PARENT: "Родитель",
    ADMIN: "Школьный администратор",
    PUPIL: "Ученик",
    DEPARTMENT: "Сотрудник департамента",
    MUNICIPALITY: "Сотрудник муниципалитета",
    NO_ROLE: "Сотрудник школы",
  },
  TASK_STATE_CHOICES: {
    PROCESSING: "Выполняется",
    COMPLETE: "Завершена",
    ABORT: "Отмена",
    ERROR: "Ошибка",
  },
  TASK_LEVEL_CHOICES: {
    SCHOOL: "Школа",
    DEPARTMENT: "Мунициполитет",
    FULL: "Полная",
  },
  LOG_TASK_CHOICES: {
    GET_SCHOOL: "Получение школ",
    GET_CLASSES: "Получение классов",
    SET_SCHOOL: "Запись школ",
    SET_CLASSES: "Запись классов",
    SET_DEPARTMENT: "Запись муниципалитетов",
    GET_DEPARTMENT: "Получение муниципалитетов",
    GET_EMPLOYEE: "Получение сотрудников",
    SET_EMPLOYEE: "Запись сотрудников",
    SET_PUPIL: "Запись учеников",
    GET_PUPIL: "Получение ученики",
  },
};
